










































































import Vue, { PropType } from 'vue';
import * as InputValidation from '@/mixins/inputValidation';
import { Objective } from '@/models/packet';

import Goal from '@/components/Goal.vue';

export default Vue.extend({
  components: {
    Goal
  },

  props: {
    value: String,
    color: String,
    objectives: Array as PropType<Objective[]>
  },

  data() {
    return {
      valueInput: this.value,
      indicatorColor: this.color,
      colorPickerColor: this.color,
      isPickingColor: false
    };
  },

  computed: {
    isSaveDisabled(): boolean {
      return (
        (this.valueInput === this.value &&
          this.indicatorColor === this.color) ||
        !this.valueValidation.valid
      );
    },

    valueValidation(): InputValidation.InputLengthValidation {
      return InputValidation.validateInput(this.valueInput, 250);
    }
  },

  methods: {
    saveIndicator() {
      this.$emit('save', {
        value: this.valueInput,
        color: this.indicatorColor
      });

      this.valueInput = this.value;
      this.indicatorColor = this.color;
    },

    close() {
      this.$emit('close');
    },

    editColorStart() {
      this.colorPickerColor = this.indicatorColor;
      this.isPickingColor = true;
    },

    editColorStop() {
      this.isPickingColor = false;
    },

    selectColor() {
      this.indicatorColor = this.colorPickerColor;

      this.editColorStop();
    }
  },

  watch: {
    value(current, previous) {
      if (current !== previous) {
        this.valueInput = current;
      }
    },

    color(current, previous) {
      if (current !== previous) {
        this.indicatorColor = current;
      }
    }
  }
});
